module.exports = __WEBPACK_EXTERNAL_MODULE_100__;


//////////////////
// WEBPACK FOOTER
// external "@angular/http"
// module id = 100
// module chunks = 0